import AxiosInstance from "../services/networkServices";

export const getAboutYouUserList = (payload) =>
  AxiosInstance.get(
    `/api/report/user-report?page=${payload?.page}&limit=10&${
      payload?.period ? `period=${payload?.period}` : ""
    }&startDate=${payload?.startDate}&endDate=${payload?.endDate}`
  );

export const getActiveUsersList = (payload) =>
  AxiosInstance.post("/api/analytics/active-users", payload);

export const getActiveUsersMonthComparison = payload =>
  AxiosInstance.post("/api/analytics/active-user-trends", payload)

export const getRetentionUsersList = (payload) =>
  AxiosInstance.post("/api/analytics/retention", payload);

export const getGraphData = (payload) =>
  AxiosInstance.post("/api/analytics/analytics-dashboard", payload);

export const getIncomeUserList = (payload) =>
  AxiosInstance.get(
    `/api/report/income-report?page=${payload?.page}&limit=10&${
      payload?.period ? `period=${payload?.period}` : ""
    }&startDate=${payload?.startDate}&endDate=${payload?.endDate}`
  );
export const getExpenseUserList = (payload) =>
  AxiosInstance.get(
    `/api/report/expense-report?page=${payload?.page}&limit=10&${
      payload?.period ? `period=${payload?.period}` : ""
    }&startDate=${payload?.startDate}&endDate=${payload?.endDate}`
  );
export const downloadReport = (payload) =>
  AxiosInstance.get(
    `/api/report/download-report?page=1&report=${payload?.report}&${
      payload?.period ? `period=${payload?.period}` : ""
    }&startDate=${payload?.startDate}&endDate=${payload?.endDate}`
  );

export const downloadRetentionReport = (payload) =>
  AxiosInstance.post("/api/analytics/download-report", payload);
